import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Modale de réinitialisation de mot de passe
 */
const ForgotPasswordModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const { t } = useTranslation();
  const { resetPassword, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    if (!email.trim()) {
      setError(t('validation.emailRequired'));
      return false;
    } 
    
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError(t('validation.emailInvalid'));
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      const { success } = await resetPassword(email);
      if (success) {
        setIsSubmitted(true);
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('auth.resetPassword')}>
      {isSubmitted ? (
        <div className="text-center py-4">
          <div className="rounded-full bg-green-100 w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gris-fonce mb-2">
            {t('auth.resetPasswordSent')}
          </h3>
          <p className="text-sm text-gris-fonce/80 mb-6">
            {t('auth.checkEmail')}
          </p>
          <button
            type="button"
            onClick={onSwitchToLogin}
            className="w-full bg-bleu1 text-white py-2 px-4 rounded-md hover:bg-bleu3 transition"
          >
            {t('auth.login')}
          </button>
        </div>
      ) : (
        <>
          <p className="text-sm text-gris-fonce/80 mb-4">
            {t('auth.resetPasswordInstructions')}
          </p>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gris-fonce mb-1">
                {t('auth.email')}
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                className={`w-full px-3 py-2 border rounded-md shadow-sm ${
                  error ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 focus:ring-bleu1`}
              />
              {error && (
                <p className="mt-1 text-sm text-red-600">{error}</p>
              )}
            </div>
            
            <button
              type="submit"
              className="w-full bg-bleu1 text-white py-2 px-4 rounded-md hover:bg-bleu3 transition"
              disabled={loading}
            >
              {loading ? t('common.loading') : t('auth.resetPassword')}
            </button>
          </form>
          
          <div className="mt-4 text-center">
            <button
              type="button"
              onClick={onSwitchToLogin}
              className="text-sm font-medium text-bleu1 hover:text-bleu3"
            >
              {t('common.backToHome')}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ForgotPasswordModal;
